<template>
  <Search />
  <Table />
</template>
<script>
import {
  // getRoleList,
  // addRole,
  systemList,
  invalidRole,
  changeRole,
  getRoleEmployee,
  changeRoleEmployee,
  // getPagePermissionByRole,
  changePermissionByRole
} from 'server/modules/ssoApi.js'
import {
  role_list_get,
  role_operate_post,
  role_delete_post,
  role_query_menu_get,
  common_info_get
} from 'server/modules/351.js'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { useStore } from 'vuex'
import {
  provide,
  onMounted,
  reactive,
  toRefs,
  watchEffect,
  createVNode,
  watch
} from 'vue'
import { Modal } from 'ant-design-vue'
import { message } from 'ant-design-vue'
import Search from './components/Search'
import Table from './components/Table'
export default {
  name: 'roleManage',
  components: {
    Search,
    Table
  },
  setup() {
    const store = useStore()
    const state = reactive({
      openMenus: [],
      checks: [],
      modifierId: '',
      id: '',
      roleId: '',
      roleName: '',
      creatorId: '',
      userId: '',
      systemId: undefined,
      name: null,
      roleIds: [],
      systems: [],
      title: '',
      visible: false,
      permissionIds: [],
      searchKeyword: '',
      pageNum: 1,
      pageSize: 10,
      total: 0,
      list: [],
      roles: [],
      roleList: [],
      userIds: [],
      menuList: [],
      tablePagination: {
        current: 1, //当前页数 v-model
        defaultPageSize: 10,
        defaultCurrent: 1,
        // defaultCurrent: 1, //默认的当前页数
        pageSize: 10, //每页显示几条数据
        showQuickJumper: true, //是否显示直通车
        total: 0, //总数
        local: 'zh',

        pageSizeOptions: ['10', '20', '50', '100'],
        showSizeChanger: true,
        showLessItems: true,
        onShowSizeChange: (current, pageSize) => {
          state.tablePagination.current = current
          state.tablePagination.pageSize = pageSize
          state.initData()
        },
        onChange: (current, pageSize) => {
          state.tablePagination.current = current
          state.tablePagination.pageSize = pageSize
          state.initData()
        },
        showTotal: total => `共 ${total} 条数据`
      },
      setAttrs: (name, value) => {
        state[name] = value
      },
      // 修改页码
      changePage: pageNum => {
        state.pageNum = pageNum
      },
      // 展示弹窗
      showModal: titleValue => {
        state.title = titleValue
        state.visible = true
      },
      // 隐藏弹窗
      handleOk: () => {
        state.visible = false
      },
      // 搜索筛选
      searchKeywordChange: e => {
        state.searchKeyword = e.target.value
      },
      // 初始化字典
      initSystems: async () => {
        const { success, data } = await systemList()
        if (success) {
          const { list } = data
          state.systems = list
          const defaultSystem = list.find(item => {
            return item.systemCode === 'auth'
          })
          state.systemId = defaultSystem.id
        }
      },
      // 获取列表
      initData: async () => {
        const { systemId, name } = state
        const { current, pageSize } = state.tablePagination
        const { data } = await role_list_get({
          menuSystemId: systemId !== -1 ? systemId : null,
          name,
          pageNum: current,
          pageSize
        })
        const { list, total } = data
        state.tablePagination.total = total
        state.list = list
      },
      fetchBase() {
        common_info_get().then(res => {
          console.log('基础信息', res)
          state.roles = res.data.role
          state.systems = res.data.menuSystem
          // const defaultSystem = res.data.menuSystem.find(item => {
          //   return item.systemCode === 'auth'
          // })
          // state.systemId = defaultSystem.id
        })
      },
      addRoleInfo: async params => {
        const { name, menuSystemId } = params
        const res = await role_operate_post({
          name,
          menuSystemId
        })
        return res
      },
      updateRoleName: async () => {
        const { roleName, id, modifierId } = state
        const { success } = await changeRole({
          id,
          modifierId,
          roleName
        })
        if (success) {
          state.id = ''
          state.modifierId = ''
          state.roleName = ''
          message.info('修改角色名称成功！')
          state.visible = false
          state.initData()
        } else {
          message.info('修改角色名称失败！')
        }
      },
      invalidRole: async params => {
        const { id, modifierId } = params

        Modal.confirm({
          icon: createVNode(ExclamationCircleOutlined),
          title: '确定废弃本条数据?',
          content: '废弃之后，对应角色的人员可能会无法正常进入系统！',
          okText: '确定',
          onOk: async () => {
            const { success } = await invalidRole({
              id,
              modifierId,
              status: -1
            })
            if (success) {
              message.info('操作成功！')
              state.initData()
            } else {
              message.error('操作失败！')
            }
          },
          cancelText: '取消',
          onCancel() {
            Modal.destroyAll()
          }
        })
      },
      deleteRole: params => {
        const { id } = params

        Modal.confirm({
          icon: createVNode(ExclamationCircleOutlined),
          title: '确定删除本条数据?',
          content: '删除之后，对应角色的人员将无法正常进入系统！',
          okText: '确定',
          okType: 'danger',
          onOk: async () => {
            const { success } = await role_delete_post({
              id
            })
            if (success) {
              message.success('删除成功！')
              state.initData()
            } else {
              message.error('操作失败！')
            }
          },
          cancelText: '取消',
          onCancel() {
            Modal.destroyAll()
          }
        })
      },
      getUpdateRoles: async (text, title) => {
        state.creatorId = store.state.user.userId
        state.visible = true
        state.title = title
        state.id = text.id
        const {
          success,
          data: { list }
        } = await getRoleEmployee({ roleId: state.id })
        if (success) {
          state.roleList = list
        }
      },
      changeRole: async () => {
        const { success } = await changeRoleEmployee({
          creatorId: state.creatorId,
          roleId: state.id,
          userIds: state.userIds
        })
        if (success) {
          state.id = ''
          state.modifierId = ''
          state.roleName = ''
          message.info('修改角色名称成功！')
          state.visible = false
          state.initData()
        } else {
          message.info('修改角色名称失败！')
        }
      },
      getMenuList: async id => {
        const res = await role_query_menu_get({
          roleId: id
        })
        return res
      },
      // 深度遍历权限id
      deepPermission: sons => {
        let emp = []
        sons.map(v => {
          if (v.selected) {
            emp.push(v.id)
          }
          state.checkedChildren(v)
          if (v.childrenList) {
            emp = [...emp, ...state.deepPermission(v.childrenList)]
          }
        })

        return emp
      },
      // 初始化保存选中的菜单
      checkedChildren: v => {
        const copy = Object.assign({}, v)
        copy.childrenList = []
        v.childrenList &&
          v.childrenList.reduce((previous, item) => {
            if (item.selected) {
              previous.push(item)
            }
            return previous
          }, copy.childrenList)
        state.openMenus.push(copy)
      },
      updateRoot: async () => {
        const { success } = await changePermissionByRole({
          creatorId: store.state.user.userId,
          permissionIds: state.permissionIds,
          roleId: state.id
        })
        if (success) {
          state.id = ''
          state.modifierId = ''
          state.roleName = ''
          message.info('修改角色权限成功！')
          state.visible = false
          state.initData()
        } else {
          message.info('修改角色权限失败！')
        }
      }
    })

    onMounted(() => {
      const { fetchBase, initData } = state
      fetchBase()
      initData()
    })

    watch(
      () => state.systemId,
      id => {
        console.log(id)
        state.tablePagination.current = 1
        // sta
      }
    )

    watchEffect(() => {
      // const { initData } = state
      // initData()
    })

    provide('state', state)

    return {
      ...toRefs(state)
    }
  }
}
</script>
